import { post, get } from '../../../services/request';


// // Provider Profile Provider Metrics -chart- start
// export const RadProfileChartDetails = (payload) => {
//     return post('Radiologist/GetRadiologistProfileChartDetails', payload);
// };

// //-------------------Provider Profile Provider Metrics -chart- end----------------//
export const getAllCustomViews = data => get(`Radiologist/GetAllRadiologistCustomViewsByUserID?UserID=${data}`)
export const getCustomViewFields = data => get(`Radiologist/GetCustomViewFiedsByViewID?ViewID=${data}`);
export const saveCustomView = data => post('Radiologist/SaveRadiologistCustomView', data);
 